import axios from 'axios'
import pageReserveForm from '../common/pages/reserve/form'
import pageEventsForm from '../common/pages/events/form'
import pageContactForm from '../common/pages/contact/form'

// 設定
const el = document.querySelector('meta[name="csrf-token"]')
axios.defaults.headers.common['X-CSRF-TOKEN'] = el ? el.getAttribute('content') : null

// ページ別
const pages = {
    reserve: {
        form: pageReserveForm,
    },
    events: {
        form: pageEventsForm,
    },
    contact: {
        form: pageContactForm,
    }
}
window.App = {pages}
